import * as type from '../types/pipeline'

export const retrieveAllPipelines = payload => {
    return{
        type: type.REQUEST_FETCH_ALL_PIPELINES,
        payload: payload
    }
}

export const resetAllPipelines = () => {
    return{
        type: type.RESET_FETCH_ALL_PIPELINES
    }
}

export const retrieveSinglePipelineDetails = payload => {
    return{
        type: type.REQUEST_SINGLE_PIPELINE_DETAILS,
        payload: payload
    }
}

export const resetSinglePipelineDetails = payload => {
    return{
        type: type.RESET_SINGLE_PIPELINE_DETAILS
    }
}

export const nullSinglePipelineDetails = payload => {
    return{
        type: type.NULL_SINGLE_PIPELINE_DETAILS
    }
}

export const requestMovePipelineData = payload => {
    return{
        type: type.REQUEST_MOVE_PIPELINE_DATA,
        payload: payload
    }
}

export const resetMovePipelineData = payload => {
    return{
        type: type.RESET_MOVE_PIPELINE_DATA
    }
}

export const retrieveUpdatedPipelineDetails = payload => {
    return{
        type: type.REQUEST_UPDATED_PIPELINE_DETAILS,
        payload: payload
    }
}

export const resetUpdatedPipelineDetails = payload => {
    return{
        type: type.RESET_UPDATED_PIPELINE_DETAILS
    }
}

export const changePipelineModal = payload => {
    return{
        type: type.CHANGE_PIPELINES_MODALS,
        modal: payload
    }
}

export const requestSearchSingleCompany = payload => {
    return{
        type: type.REQUEST_SEARCH_SINGLE_COMPANY,
        id: payload
    }
}

export const resetSearchSingleCompany = () => {
    return{
        type: type.RESET_SEARCH_SINGLE_COMPANY,
    }
}

export const requestAddSingleOpportunity = payload => {
    return{
        type: type.REQUEST_ADD_SINGLE_OPPORTUNITY,
        details: payload
    }
}

export const resetAddSingleOpportunity = () => {
    return{
        type: type.RESET_ADD_SINGLE_OPPORTUNITY
    }
}

export const setActivePipelineUnit = payload => {
    return{
        type: type.SET_ACTIVE_PIPELINE_UNIT,
        unit: payload
    }
}

export const resetActivePipelineUnit = payload => {
    return{
        type: type.RESET_ACTIVE_PIPELINE_UNIT
    }
}

export const requestUpdatePipelineUnit = payload => {
    return{
        type: type.REQUEST_UPDATE_SINGLE_OPPORTUNITY,
        details: payload
    }
}

export const resetUpdatePipelineUnit = () => {
    return{
        type: type.RESET_UPDATE_SINGLE_OPPORTUNITY
    }
}

export const requestDeletePipelineUnit = payload => {
    return{
        type: type.REQUEST_DELETE_SINGLE_OPPORTUNITY,
        details: payload
    }
}

export const resetDeletePipelineUnit = () => {
    return{
        type: type.RESET_DELETE_SINGLE_OPPORTUNITY
    }
}

export const requestCreateNewPipeline = payload => {
    return{
        type: type.REQUEST_CREATE_NEW_PIPELINE,
        details: payload
    }
}

export const resetCreateNewPipeline = () => {
    return{
        type: type.RESET_CREATE_NEW_PIPELINE
    }
}

export const setActiveEditPipeline = payload => {
    return{
        type: type.SET_EDIT_SINGLE_PIPELINE,
        pipeline: payload
    }
}

export const resetActiveEditPipeline = payload => {
    return{
        type: type.RESET_EDIT_SINGLE_PIPELINE
    }
}

export const requestDeleteSinglePipeline = payload => {
    return{
        type: type.REQUEST_DELETE_SINGLE_PIPELINE,
        details: payload
    }
}

export const resetDeleteSinglePipeline = payload => {
    return{
        type: type.RESET_DELETE_SINGLE_PIPELINE
    }
}

export const requestUpdateSinglePipeline = payload => {
    return{
        type: type.REQUEST_UPDATE_SINGLE_PIPELINE,
        details: payload
    }
}

export const resetUpdateSinglePipeline = payload => {
    return{
        type: type.RESET_UPDATE_SINGLE_PIPELINE
    }
}

